import * as React from "react";

import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import ToggleButton from "@material-ui/lab/ToggleButton";

export interface SimpleToggleProps extends React.Props<any> {
    labels: string[];
    values: string[];
    defaultValue?: string;
    className?: any;
    onChange: (value: any) => void;
}

const SimpleToggle = (props: SimpleToggleProps) => {
    let [selectedValue, setSelectedValue] = React.useState<string>(
        props.defaultValue ? props.defaultValue : props.values[0]
    );

    const handleOnChanged = (event: any, value: any) => {
        setSelectedValue(value);
        props.onChange(value);
    };

    if (props.labels.length !== props.values.length) {
        return null;
    }

    return (
        <ToggleButtonGroup color="primary" exclusive={true} value={selectedValue} onChange={handleOnChanged}>
            {props.values.map((value, index) => (
                <ToggleButton className={props.className} value={value}>
                    {props.labels[index]}
                </ToggleButton>
            ))}
        </ToggleButtonGroup>
    );
};

export default SimpleToggle;
